var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-select',{attrs:{"expanded":true,"value":_vm.value,"placeholder":`${_vm.$tc('select')} ${_vm.$tc('operationMode')}...`},on:{"input":_vm.onChange}},[_c('option',{attrs:{"value":"Habilitation"}},[_vm._v(" "+_vm._s(_vm.$tc('habilitation'))+" ")]),_c('option',{attrs:{"value":"Production"}},[_vm._v(" "+_vm._s(_vm.$tc('production'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }